import React from 'react';
import ColorSelection from './ColorSelection';
import useDrawSliders from './useDrawSliders';
import DrawSlider from './DrawSlider';
import useAppState from '../../../AppStore';
import RadiusSetting from './RadiusSetting';
import DrawListTool from '../drawList/DrawListTool';
import FilledOutSetting from './FilledOutSetting';
import CoordinatesSetting from './CoordinatesSetting';
import TextSetting from './TextSetting';

const DrawSettings = () => {
  const setActiveView = useAppState((state) => state.setActiveView);
  const {
    displayedSliders,
    displayRadius,
    displayFilledOut,
    feature,
    displayCoordinates,
    displayText,
  } = useDrawSliders();

  if (!feature || !displayedSliders) {
    setActiveView('draw_tool');
    return null;
  }

  return (
    <div className="draw-settings scrollable">
      <DrawListTool feature={feature} />
      <ColorSelection />

      {displayFilledOut && <FilledOutSetting />}
      {displayRadius && <RadiusSetting />}
      {displayCoordinates && <CoordinatesSetting />}
      <div className="draw-settings__sliders">
        {displayedSliders.map((slider) => (
          <DrawSlider key={slider} slider={slider} />
        ))}
      </div>
      {displayText && <TextSetting />}
    </div>
  );
};

export default DrawSettings;
